export class SoYearWisePlanningDetails {
    finYear: string;
    finMonth: string;
    plantCode: string;
    openSos: string;
    closesSos: string;
    cancelledSos: string
}